import { GlobalCard } from '@global-engineering-shared/gweb-material-lab';
import { Grid, Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import { Frame } from 'features/Frames/types';
import { stateColour, stateFormatter } from 'features/Status/utils/state';
import { getTimeSince } from 'utils/dateTime';

import useStyles from './FrameStatusCard.styles';

type FrameStatusCardProps = {
  currentFrame: Frame;
};

const FrameStatusCard = ({ currentFrame }: FrameStatusCardProps) => {
  const classes = useStyles({ statusColour: stateColour(currentFrame.status?.state) });

  return (
    <GlobalCard className={classes.card}>
      <Grid className={classes.grid}>
        <Typography variant="h2" fontWeight="bold" className={classes.status}>
          {stateFormatter(currentFrame.status?.state)}
        </Typography>
        <Typography variant="body1" className={classes.message}>
          Updated {getTimeSince(currentFrame.status?.time)} ago
        </Typography>
      </Grid>
    </GlobalCard>
  );
};

export default FrameStatusCard;
